
angular.module('Services')
    .factory('BBAProfileManagerService', function ($http, $rootScope, Error, Request) {
        return {
            getAll: function(callback, errorCallback, filter) {
                Request.get({
                    url: ApiURLs.bbaProfileManager,
                    successCallback: callback,
                    errorCallback: errorCallback,
                    data: filter
                });
            },
            get: function(callback, errorCallback, id) {
                Request.get({
                    url: ApiURLs.bbaProfileManager + id,
                    successCallback: callback,
                    errorCallback: errorCallback,
                });
            },
            update: function(id, payload, callback, errorCallback) {
                Request.post({
                    url: ApiURLs.bbaProfileManager + id,
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errorCallback
                }, payload);
            },
            create: function(payload, callback, errorCallback) {
                Request.post({
                    url: ApiURLs.bbaProfileManager,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errorCallback,
                }, payload);
            },
            getQuote: function(payload, callback, errorCallback, mileProfile) {
                Request.post({
                    url: ApiURLs.carrier.getQuote + mileProfile,
                    method: 'POST',
                    successCallback: callback,
                    errorCallback: errorCallback
                }, payload)
            },
            uploadLogo: function(file, bbaProfileId, callback, errorCallback) {
                Request.upload({
                    url: ApiURLs.breakBulk.uploadLogo.replace(':bbaProfileId', bbaProfileId),
                    method: 'PUT',
                    successCallback: callback,
                    errorCallback: errorCallback,
                    headers: {
                        'Accept': 'plain/text'
                    }
                }, file);
            },
            getCustomsManifestSettings: function(carrierId, successCallback, errorCallback) {
                Request.get({
                    url: ApiURLs.breakBulk.customsManifestSettings.replace(':carrierId', carrierId),
                    successCallback: successCallback,
                    errorCallback: errorCallback
                });
            }
        }
    });



// WEBPACK FOOTER //
// ./js/services/BBAProfileManagerService.js